// Asnyc component + Webpack Code splitting
const Login = () => import(/* webpackChunkName: "Login" */ './Login');
const Audit = () => import(/* webpackChunkName: "Audit" */ './Audit');
const Dashboard = () =>
  import(/* webpackChunkName: "Dashboard" */ './Dashboard');

export const ROUTES = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/audit',
    name: 'Audit',
    component: Audit,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
];
